// extracted by mini-css-extract-plugin
module.exports = {"container":"DietsPage_container__3jL7N"};